export const tooltips = {
    property_value: 'Value of the property you are purchasing.',
    loan_amount: 'Amount you would like to borrow.',
    deposit_amount: 'Enter the deposit amount you have.',
    state: 'State or Territory property is in.',
    property_type: `Select what you're going to use the property for.`,
    property_status:
        'An established home is a property that has been lived in while a new home has never been occupied or sold.',
    first_home_buyer: `If this is the first time you're purchasing a home, select yes.`,
    foreign_buyer: 'If you are not an Australian resident, select yes',
    loan_term: 'Length of time you are planning to keep the loan.',
    interest_rate:
        'The interest rate varies based on your loan and other scenarios.',
    repayment_type: 'The repayment type you are interested in.',
    repayment_frequency: 'The frequency you would like to pay off your loan.',
    eligible_pensioner: `If you are currently an eligible pensioner or meet current criteria of a pensioner, select yes.`,
    total_income: `Input the total income of all the purchasers. Your partner’s income must also be included even if he/she will not be the owner of the property. 
    `,
    no_of_dependent: `Input the number of dependent children.`,
    payment_method: `Selecting either paper transaction or electronic transaction will affect the cost of the mortgage registration fee and land transfer fee.`,
    vic_property_location: `Select which local government area you intend to buy property in Victoria.`,
    wa_property_location: `Select if the property is located either in the South or North of the 26th parallel.`,
    transaction: `Transaction type of the loan.`,
    guarantors_property_value: `Estimated value of your guarantor’s property.`,
    guarantors_loan_amount: `Amount the guarantor owes on the mortgage. Enter 0 if they don't have any mortgage.`
}
